import { fetchProfileForRouteGuard } from '~~/layers/base/composables/fetchProfileForRouteGuard'
import { denyStaffAdminRoute } from '~~/layers/base/utils/denyStaffAdminRoute'

/**
 * Named route middleware: only users with `public.profile.is_admin` may enter the route.
 *
 * Anonymous sessions and non-admin accounts are redirected to `/admin/login`.
 *
 * Usage on a page:
 * `definePageMeta({ middleware: 'is-admin' })`
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const profile = await fetchProfileForRouteGuard()
    if (!profile) {
        return denyStaffAdminRoute(to, 'unauthenticated')
    }
    if (!profile.isAdmin) {
        return denyStaffAdminRoute(to, 'forbidden')
    }
})
